<template>
  <router-view></router-view>
</template>

<script>
export default {
  watch: {
    '$route.params.projectSlug': {
      handler: function(newValue, prevValue) {
        this.updateProject(prevValue, newValue);
      },
      immediate: true,
    },
    schema: {
      handler: function(newSchema) {
        // sync with projects array.
        this.updateProject(this.activeProject, '');
      },
      deep: true,
    },
  },
  methods: {
    updateProject(prevSlug, newSlug) {
      console.log(prevSlug, newSlug);
      // 1. store prev schema in projects
      let prevProjectIndex = this.projects.findIndex(project => project.project_path === prevSlug);
      if (prevProjectIndex !== -1) {
        let prevProjectNewData = {
          ...this.projects[prevProjectIndex],
          schema: JSON.parse(JSON.stringify(this.schema)),
        };
        this.projects.splice(prevProjectIndex, 1, prevProjectNewData);
      }

      // 2. init new Schema:
      let currentProjectIndex = this.projects.findIndex(project => project.project_path === newSlug);
      if (currentProjectIndex !== -1) {
        this.schema = this.projects[currentProjectIndex].schema;
        console.log(currentProjectIndex, this.schema);
        this.activeProject = this.projects[currentProjectIndex].project_path;
      }
    },
  },
  computed: {
    projects: {
      get: function() {
        return this.$store.state.projects;
      },
      set: function(newProjects) {
        this.$store.dispatch('setProjects', newProjects);
      },
    },
    activeProject: {
      get: function() {
        return this.$store.state.activeProject;
      },
      set: function(newActive) {
        this.$store.dispatch('setActiveProject', newActive);
      },
    },
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
  },
  // beforeRouteLeave() {
  //   try {
  //     this.projects(this.$route.params.projectSlug, '');
  //   } catch (err) {
  //     //
  //   }
  // },
};
</script>

<style></style>
